import { useState } from 'react';
import WebApp from '@twa-dev/sdk';
import type { MeResponse } from '../lib/api.js';

interface Props {
  onBack: () => void;
  me: MeResponse | null;
}

const PHASES = [
  { week: '1-3', title: 'Phase 1 — Foundation', desc: '기본기 + 볼륨 빌딩', color: '#94a3b8' },
  { week: '4-6', title: 'Phase 2 — Strength', desc: '강도 ↑ + 약점 보강', color: '#60a5fa' },
  { week: '7-9', title: 'Phase 3 — Power', desc: '폭발력 + 인터벌', color: '#34d399' },
  { week: '10-12', title: 'Phase 4 — Peak', desc: '대회 직전 피킹', color: '#fbbf24' },
];

export function TwelveWeekTracker({ onBack, me }: Props) {
  // 멤버 프로필에서 currentPhase 가져옴 (없으면 1로 시작)
  const profilePhase = me?.fitnessProfile?.currentPhase ?? 1;
  const [currentPhase] = useState(profilePhase);
  // currentWeek는 phase 시작점 + 추정 (Phase별 3주씩, 중간 가정)
  const [currentWeek] = useState((profilePhase - 1) * 3 + 2);

  return (
    <div className="app">
      <button className="back-link" onClick={onBack}>← 홈</button>
      <h1>📊 12주 트래커</h1>

      <div style={{ marginTop: 16, marginBottom: 24 }}>
        <p style={{ fontSize: 14, color: 'var(--tg-hint)' }}>
          현재 <strong style={{ color: 'var(--tg-text)' }}>{currentWeek}/12주</strong> · Phase {currentPhase}/4
        </p>
        <div className="progress" style={{ marginTop: 12 }}>
          <div
            className="progress-bar"
            style={{ width: `${(currentWeek / 12) * 100}%` }}
          />
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {PHASES.map((p, i) => {
          const isCurrent = i + 1 === currentPhase;
          const isPast = i + 1 < currentPhase;
          return (
            <div
              key={p.week}
              style={{
                padding: 16,
                borderRadius: 12,
                background: isCurrent ? p.color + '20' : 'var(--tg-secondary)',
                border: isCurrent ? `2px solid ${p.color}` : '2px solid transparent',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 24 }}>{isPast ? '✅' : isCurrent ? '🔥' : '⚪'}</span>
                <div style={{ flex: 1 }}>
                  <strong style={{ display: 'block' }}>{p.title}</strong>
                  <small style={{ color: 'var(--tg-hint)' }}>주 {p.week} — {p.desc}</small>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button
        className="btn"
        style={{ marginTop: 24 }}
        onClick={() => {
          WebApp.HapticFeedback?.impactOccurred?.('light');
          WebApp.showAlert('이번주 완료 체크! (Phase 1+ DB 연동 예정)');
        }}
      >
        ✅ 이번주 운동 완료 체크
      </button>
    </div>
  );
}
